import { render, staticRenderFns } from "./ShowJournal.vue?vue&type=template&id=e866c472&scoped=true"
import script from "./ShowJournal.vue?vue&type=script&lang=js"
export * from "./ShowJournal.vue?vue&type=script&lang=js"
import style0 from "./ShowJournal.vue?vue&type=style&index=0&id=e866c472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e866c472",
  null
  
)

export default component.exports